var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcon2 = function SvgIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 20H10a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-2 12v18a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V32m20-12v32m11.325-34.825C40.475 20 32 20 32 20s0-8.475 2.825-11.325a6.01 6.01 0 1 1 8.5 8.5v0Zm-22.65 0C23.525 20 32 20 32 20s0-8.475-2.825-11.325a6.01 6.01 0 1 0-8.5 8.5v0Z",
    stroke: "#888DFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIcon2;